<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Etapa: {{stage.title}}</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <router-link class="btn btn-outline-secondary" to="/etapas">{{cancelBtn.value}}</router-link>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <template v-else>
                <b-form v-on:submit.prevent="onSubmit">
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group id="lotTitle" label="Nombre:" label-for="lotTitleInput" description="">
                                <b-form-input v-model="stage.title" id="lotTitleInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group id="lotVideo" label="Video:" label-for="lotVideoInput" description="">
                                <b-form-input v-model="stage.video" id="lotVideoInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">

                            <div class="image__grid">
                                <div class="image__grid__item" v-for="(image, index) in stage.images" :key="index">
                                    <span class="image__grid__close" @click="deleteImage(index)">X</span>
                                    <img :src="image.url" :alt="image.title">
                                </div>
                            </div>
                            <b-form-group id="lotImages" label="Imágenes:" label-for="lotImagesInput" description="">
                                <b-form-file
                                        id="lotImagesInput"
                                        v-model="images"
                                        v-on:input="onFileChange"
                                        :multiple="Boolean(true)"
                                        ref="imagesField"
                                        accept="image/jpeg"
                                        placeholder="Selecciona uno o mas imágenes..."
                                        drop-placeholder="Arrastra hasta aquí..."
                                ></b-form-file>
                            </b-form-group>

                        </b-col>
                    </b-form-row>

                    <b-form-row>
                        <b-col md="12">

                            <b-table hover v-bind:items="stage.documents" v-bind:fields="documentHeaders"
                                     outlined
                                     head-variant="light">
                                <template slot="file" slot-scope="data">
                                    <b-link v-bind:to="data.item.file.url" target="_blank">{{data.item.file.name}}
                                    </b-link>
                                </template>
                                <template slot="title" slot-scope="data">
                                    <input type="text" v-model="data.item.title">
                                </template>
                                <template slot="actions" slot-scope="data">
                                    <div class="btn-group">
                                        <b-button variant="outline-secondary" size="sm"
                                                  @click="deleteDocument(data.index)">Eliminar
                                        </b-button>
                                    </div>
                                </template>
                            </b-table>

                            <b-form-group id="stageDocuments" label="Documentos:" label-for="stageDocumentsInput"
                                          description="">
                                <b-form-file
                                        id="stageDocumentsInput"
                                        v-model="documents"
                                        v-on:input="onDocumentsChange"
                                        :multiple="Boolean(true)"
                                        ref="documentsField"
                                        placeholder="Selecciona uno o mas documentos..."
                                        drop-placeholder="Arrastra hasta aquí..."
                                ></b-form-file>
                            </b-form-group>

                        </b-col>
                    </b-form-row>

                    <b-button type="submit" variant="primary" v-bind:disabled="submitBtn.disabled">{{submitBtn.value}}
                    </b-button>
                </b-form>
                <hr>
            </template>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "StagesAdd",
        data() {
            return {
                isLoading: true,
                images: [],
                imageHeaders: [
                    {key: 'image', label: 'Imagen', sortable: false},
                    {key: 'url', label: 'Ruta de archivo', sortable: true}
                ],
                documents: [],
                documentHeaders: [
                    {key: 'file', label: 'Archivo', sortable: false},
                    {key: 'title', label: 'Título', sortable: false},
                    {key: 'actions', label: 'Acciones', sortable: false},
                ],
                cancelBtn: {
                    value: "Cancelar edición"
                },
                submitBtn: {
                    disabled: false,
                    value: "Actualizar"
                },
                deleteBtn: {
                    disabled: false,
                    value: "Eliminar esta etapa"
                }
            }
        },
        computed: {
            ...mapGetters({
                stage: 'stages/getEntries',
                newImages: 'images/getImages',
                newDocuments: 'documents/getDocuments',
            })
        },
        methods: {
            onFileChange(files) {

                return this.$store.dispatch('images/loadImages', files).then(() => {
                    this.stage.images = [...this.stage.images, ...this.newImages];
                });

            },
            onDocumentsChange(files) {

                return this.$store.dispatch('documents/loadDocuments', files).then(() => {
                    this.stage.documents = [...this.stage.documents, ...this.newDocuments];
                });

            },
            deleteImage(index) {
                this.stage.images.splice(index, 1);
            },
            deleteDocument(index) {
                this.stage.documents.splice(index, 1);
            },
            onSubmit() {

                this.submitBtn.disabled = true;
                this.submitBtn.value = "Actualizando...";

                this.$store.dispatch('stages/updateEntry').then(() => {
                    this.submitBtn.value = "Etapa actualizada";
                    this.cancelBtn.value = "Regresar";
                });

            },
            deleteLot() {
                return true;
            }
        },
        created() {

            this.$store.dispatch('stages/setEntry').then(() => {
                this.isLoading = false;
            });
        }
    }
</script>

<style scoped>
    .image__grid {
        border: 1px solid #dedede;
        background-color: #f7f7f7;
        margin-bottom: 10px;
        border-radius: 3px;
    }

    .image__grid__item {
        margin: 10px;
        display: inline-block;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
        position: relative;
        max-width: 20%;
        vertical-align: text-top;
    }

    .image__grid__item img {
        max-width: 100%;
        height: auto;
    }

    .image__grid__close {
        position: absolute;
        top: 0;
        right: 0;
        background: black;
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        color: #fff;
        cursor: pointer;
        padding: 10px;
        opacity: .5;
        transition: opacity .3s ease-in-out;
    }

    .image__grid__close:hover {
        opacity: 1;
    }
</style>